import Button from '@atoms/new/button';
import Image from 'next/image';
import { ArrowSquareOutIcon as LaunchRoundedIcon } from '@phosphor-icons/react';

export const NotSupportedPage = () => {
  const handleOpenPowerpoint = () => {
    window.location.href = 'ms-powerpoint:';
  };

  return (
    <div className="w-screen h-screen flex flex-col items-center justify-center">
      <Image
        width={175}
        height={175}
        alt="streamalive logo"
        src={'/images/logos/streamalive.svg'}
        className="w-36 inline-block"
      />

      <div className="my-[40px] w-[501px]">
        <div className="text-2xl font-bold text-center">
          Please use the PowerPoint desktop app (Online not supported)
        </div>

        <div className="mt-[19px] text-lg font-normal text-default-600">
          For further support, please email us at{' '}
          <span className="underline text-default-600">
            <a href="mailto:hi@streamalive.com">hi@streamalive.com</a>
          </span>
        </div>
      </div>

      <Button
        onPress={handleOpenPowerpoint}
        endContent={<LaunchRoundedIcon size={20} />}
      >
        Open PowerPoint Desktop
      </Button>
    </div>
  );
};
